import { HISTORY_SELECTED } from './history.action';

const addToDataLayer = data => window.dataLayer.push(data);

export const HistoryAnalytics = {
  [HISTORY_SELECTED]: action => addToDataLayer({
    event: 'historyUpdated',
    data: action.payload.name || 'unknown'
  })
};
